<div class="card bg-card" [class.text]="type() === 'text'" [class.project]="type() === 'project'">
    <div class="row">
        <div [style.min-height]="height()" [class.col-10]="icon() !== undefined" [class.col-12]="icon() === undefined">
            @if (type() === "text") {
                <h5 class="fw-bold mt-1 mb-1" [title]="content()">{{ content() }}</h5>
            } @else if (type() === "progress") {
                <h5 class="fw-bold mt-1 mb-1" [title]="title()">{{ title() }}</h5>
            } @else if (type() === "project") {
                <h5 class="fw-bold mt-1 mb-1 text-primary" [title]="title()">{{ title() }}</h5>
                <h6 class="mt-1 mb-2 text-secondary" [title]="content()">{{ content() }}</h6>
            }
        </div>

        @let logo = icon();
        @if (logo !== undefined) {
            @if (typeof logo === "string") {
                <div class="col-2 d-flex justify-content-end align-items-start"><i [class]="icon()"></i></div>
            } @else if (typeof logo === "number") {
                <adaa-picture [pictureId]="logo" width="23px" height="23px" [style]="'object-fit: cover; border-radius: 50%'" />
            }
        }
    </div>

    @if (type() === "text") {
        <h6 class="mt-1 mb-0 text-secondary" [title]="title()">{{ title() }}</h6>
    } @else if (type() === "progress") {
        <adaa-progress-indicator class="w-100" [value]="progress()" [color]="progressColor()" />
    } @else if (type() === "project") {
        <span
            class="badge rounded-pill text-dark shadow-sm my-2 text-white"
            [style.background-color]="colorString()"
            [class.text-start]="AdaaHelper.getCurrentLang() === Language.English"
            [class.text-end]="AdaaHelper.getCurrentLang() === Language.Arabic"
        >
            {{ "common.tables.progress" | translate }}: {{ progress() | percentageValue }}
        </span>
        <div class="divider"></div>
        <adaa-progress-indicator
            class="w-100"
            [value]="visionScore()"
            [color]="visionScoreColor()"
            [label]="'international_projects.dashboard.impact_kpi' | translate"
        />
    }
</div>
